// src/contentful/studioQueries.js
// GraphQL query definitions for Studios/Demos data

import { gql } from 'graphql-request';

/**
 * Query to fetch all studios from Contentful
 * Used on DemosPage, MobileDemosPage, DemosSection, etc.
 *
 * Schema notes:
 * - status: live | in_lab | coming_soon (underscore format in Contentful)
 * - domain: supply_chain | knowledge | manufacturing | ai_genai | analytics | factory
 * - longDescription: Rich text field with JSON structure
 * - heroScreenshot: Asset (image)
 * - techStack: Array of strings
 * - isFeatured: Boolean
 * - sortOrder: Integer for ordering
 */
export const STUDIOS_QUERY = gql`
  query GetStudios($preview: Boolean = false) {
    studioCollection(preview: $preview, order: sortOrder_ASC) {
      total
      items {
        sys {
          id
        }
        title
        slug
        status
        domain
        shortSummary
        longDescription {
          json
        }
        heroScreenshot {
          url
          title
          description
          width
          height
        }
        demoUrl
        techStack
        isFeatured
        sortOrder
      }
    }
  }
`;

/**
 * Query to fetch a single studio by slug
 * Used for studio detail pages (if needed)
 */
export const STUDIO_BY_SLUG_QUERY = gql`
  query StudioBySlug($slug: String!) {
    studioCollection(where: { slug: $slug }, limit: 1) {
      items {
        sys {
          id
        }
        title
        slug
        status
        domain
        shortSummary
        longDescription {
          json
        }
        heroScreenshot {
          url
          title
          description
          width
          height
        }
        demoUrl
        techStack
        isFeatured
        sortOrder
      }
    }
  }
`;
